import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import { Spacer, Field, Button, Label, Divider, Checkbox, Card, Icon, Row, Col, Collapse } from '@cleartrip/bento'
import Modal from 'lib/Modal'
import ModalHeader from '../UserProfileModalHeader'
import Dropdown from 'components/Dropdown'
import langTranslate from 'locale'
import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'

import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/logPageLoadEvents'
import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg'
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg'

const isRtl = process.env.CONTENT_DIR === 'RTL'

function SignedInUserBlock({
    animatedClass,
    toggle,
    email,
    validatePasswordHandler,
    changePasswordHandler,
    isPasswordValid,
    password,
    spanClass,
    checkboxClass,
    rememberCheckedStatus,
    setRememberCheckedStatus,
    checkBoxTextClass,
    onContinue,
    clickHandler,
    handleLinkClick,
    goBackAnimation,
    showCloseButton
}) {
    return (
        <div
            className="bg-white br-4 br-4 o-hidden"
            style={{
                width: '400px',
                minHeight: '456px'
            }}
        >
            <div
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        onContinue()
                    }
                }}
                className={animatedClass}
            >
                <ModalHeader title={langTranslate('Sign in with password')} toggle={toggle} showCloseButton={showCloseButton} />
                <div style={{ minHeight: '250px' }}>
                    <OfflineToast page="sign in" />
                    <div
                        // onClick={() => clickHandler(USER_PROFILE_PAGE_CONTANTS.SIGNUP_PAGE, true)}
                        onClick={() => goBackAnimation(USER_PROFILE_PAGE_CONTANTS.SIGNUP_PAGE)}
                        className="c-pointer flex flex-middle c-secondary-500 fs-3 fw-500"
                    >
                        {!isRtl ? (
                            <ArrowLeft height={18} className="c-inherit" />
                        ) : (
                            <ArrowRight height={18} className="c-inherit" />
                        )}
                        &nbsp; <span className="fs-2">{langTranslate('Sign up')}</span>
                    </div>
                    <Spacer className="pt-6" />
                    <p className="fs-3 c-neutral-700">
                        {langTranslate('For account')} <b>{`${email}`}</b>
                    </p>
                    <Spacer className="pt-3" />
                    <div className="p-relative">
                        <Field
                            placeholder={langTranslate('Password')}
                            type="password"
                            onBlur={validatePasswordHandler}
                            onChange={changePasswordHandler}
                            hasError={!isPasswordValid}
                            value={password}
                        />
                        <span
                            onClick={() => clickHandler(USER_PROFILE_PAGE_CONTANTS.RESET_PAGE, true)}
                            className={spanClass}
                        >
                            {langTranslate('Forgot?')}
                        </span>
                        <Spacer className="pt-1" />
                        {!isPasswordValid &&
                            (password.length !== 0 ? (
                                <span className="c-error-500 fs-2 p-absolute">
                                    {langTranslate('Incorrect password')}
                                </span>
                            ) : (
                                <span data-testid="incorrectPassword" className="c-error-500 fs-2 p-absolute">
                                    {langTranslate('Password cannot be left blank')}
                                </span>
                            ))}
                    </div>

                    <Spacer className="pt-6" />
                    <div>
                        <Checkbox
                            data-testid="remember"
                            className={checkboxClass}
                            checked={rememberCheckedStatus}
                            onClick={() => setRememberCheckedStatus(!rememberCheckedStatus)}
                        >
                            <span className={checkBoxTextClass}>{langTranslate('Remember me on this browser')}</span>
                        </Checkbox>
                    </div>
                </div>
                <div style={{ direction: isRtl ? 'rtl' : '' }}>
                    <span className="c-neutral-700 fs-2">
                        {langTranslate("By signing in, you agree to Cleartrip's ")}
                    </span>
                    <span
                        className="c-secondary-500 fw-500 fs-2 hover:td-underline c-pointer"
                        onClick={() => handleLinkClick('terms-of-service')}
                    >
                        {langTranslate('Terms of Use ')}
                    </span>
                    <span className="c-neutral-700 fs-2">{langTranslate('and ')}</span>
                    <span
                        style={isRtl ? { marginRight: '-2px' } : { marginLeft: '-2px' }}
                        className="c-secondary-500 fw-500 fs-2 hover:td-underline c-pointer"
                        onClick={() => handleLinkClick('privacy-policy')}
                    >
                        {langTranslate('Privacy Policy')}
                    </span>
                    <span className="c-neutral-700 fs-2">{langTranslate('.')}</span>
                </div>
                <Spacer className="pt-3" />
                <Button size="md" type="secondary" full onClick={() => onContinue()}>
                    <span className="fs-3 fw-550">{langTranslate('Sign in')}</span>
                </Button>
            </div>
        </div>
    )
}

export default SignedInUserBlock
